import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "d-flex align-items-start flex-column" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "container mt-3"
}
const _hoisted_4 = {
  class: "btn-group btn-lg",
  role: "group"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary"
}, "Other", -1)
const _hoisted_6 = {
  key: 2,
  class: "container mt-4"
}
const _hoisted_7 = { class: "form-inline" }
const _hoisted_8 = { class: "form-group pt-3" }
const _hoisted_9 = { class: "col-sm-12 mb-2 text-left" }
const _hoisted_10 = { class: "col-sm-12 text-left" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "container mt-3 col-sm-10"
}
const _hoisted_13 = {
  key: 1,
  class: "container mt-3 col-sm-10"
}
const _hoisted_14 = {
  key: 2,
  class: "container col-sm-2"
}
const _hoisted_15 = {
  key: 3,
  class: "row"
}
const _hoisted_16 = {
  class: "col-sm-6",
  style: {"border":"pink 1px"}
}
const _hoisted_17 = { class: "col-sm-6" }
const _hoisted_18 = { class: "row mt-4" }
const _hoisted_19 = {
  key: 0,
  class: "col-sm-3"
}
const _hoisted_20 = { class: "col-sm-9" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", null, "Analysis is complete!", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 1,
  class: "card"
}
const _hoisted_25 = {
  key: 0,
  class: "row p-3 m-2"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "h6 col-sm-4 text-right" }, "Rating", -1)
const _hoisted_27 = { class: "col-sm-4" }
const _hoisted_28 = { class: "text-left" }
const _hoisted_29 = { class: "float-right" }
const _hoisted_30 = { class: "text-left" }
const _hoisted_31 = { class: "float-right" }
const _hoisted_32 = { class: "text-left" }
const _hoisted_33 = { class: "float-right" }
const _hoisted_34 = { class: "text-left" }
const _hoisted_35 = { class: "float-right" }
const _hoisted_36 = { class: "text-left" }
const _hoisted_37 = { class: "float-right" }
const _hoisted_38 = { class: "col-sm-4 text-left" }
const _hoisted_39 = {
  key: 1,
  class: "row p-3 m-2"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "h6 col-sm-4 text-right" }, "改善建議和示範", -1)
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = {
  key: 2,
  class: "row p-3 m-2"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "h6 col-sm-4 text-right" }, "Unique Vocabulary Items", -1)
const _hoisted_44 = { class: "col-sm-2" }
const _hoisted_45 = { class: "col-sm-6 h5 text-left" }
const _hoisted_46 = {
  key: 3,
  class: "row p-3 m-2"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "h6 col-sm-4 text-right" }, "Vocab Items Related To Topic", -1)
const _hoisted_48 = { class: "col-sm-2" }
const _hoisted_49 = { class: "col-sm-6 h5 text-left" }
const _hoisted_50 = {
  key: 4,
  class: "row p-3 m-2"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "h6 col-sm-4 text-right" }, "Filler Words", -1)
const _hoisted_52 = { class: "col-sm-2" }
const _hoisted_53 = { class: "col-sm-6 h5 text-left" }
const _hoisted_54 = {
  key: 5,
  class: "row p-3 m-2"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "h6 col-sm-4 text-right" }, "Sentiment", -1)
const _hoisted_56 = { class: "col-sm-2 emoticon-wrapper" }
const _hoisted_57 = { class: "col-sm-6 text-left" }
const _hoisted_58 = {
  key: 6,
  class: "row p-3 m-2"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "h6 col-sm-4 text-right" }, "家長的小提示", -1)
const _hoisted_60 = ["innerHTML"]
const _hoisted_61 = {
  class: "d-flex align-items-end flex-column",
  style: {"height":"10vh"}
}
const _hoisted_62 = { class: "col-sm-4" }
const _hoisted_63 = ["value"]

import type { Ref } from "vue";
import { ref, onMounted } from "vue";
import { getAuth, signOut } from "firebase/auth";
import { db } from "@/firebase";
import { arrayUnion, collection, doc, addDoc, getDoc, getDocs, setDoc, updateDoc, query, orderBy, startAt, endAt } from 'firebase/firestore';
import { useRoute, useRouter } from "vue-router";
import { Pie } from 'vue-chartjs';
import { useDevicesList, useUserMedia, watchOnce } from '@vueuse/core';
import { AVMedia } from 'vue-audio-visual';
import CustomRangeSlider from '../components/CustomRangeSlider.vue';
import { formatTime } from '../utils';
import * as AudioTrackSpeechRecognition from '../AudioTrackSpeechRecognition';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    ArcElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import EmoticonOutlineIcon from 'vue-material-design-icons/EmoticonOutline.vue';
import EmoticonHappyOutlineIcon from 'vue-material-design-icons/EmoticonHappyOutline.vue';
import EmoticonNeutralOutlineIcon from 'vue-material-design-icons/EmoticonNeutralOutline.vue';
import EmoticonSadOutlineIcon from 'vue-material-design-icons/EmoticonSadOutline.vue';
import EmoticonFrownOutlineIcon from 'vue-material-design-icons/EmoticonFrownOutline.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveSessionView',
  setup(__props) {

ChartJS.register(
    CategoryScale,
    LinearScale,
    ArcElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
)

let audioContext : AudioContext;
let audioTranscriber;
let auth;
let recordingSource : MediaStream;
const router = useRouter();
const {
  audioInputs: microphones
} = useDevicesList({
  requestPermissions: true,
})
const activeSpeaker = ref();
const analysisFinished = ref(false);
const analysisJson = ref();
const overallScore = ref(0);
const childStream = ref();
const transcript = ref(['']) as Ref<string[]>;
const selectedMic = ref();
const sessionLength = ref(0);
const sessionStarted = ref(false);
const showStoryInputBox = ref(false);
const storyInputBox = ref('');
const studentData = ref({});
const studentDataSaved = ref(false);
const topicInput = ref('visiting a zoo');
const timeElapsed = ref(0);
const timers = {
  child: ref(0),
  teacher: ref(0),
  percentElapsed: ref(0)
};
const volumes = {
  child: ref(0),
  teacher: ref(0)
}
const sampleCounts = {
  child: 0,
  teacher: 0
}
const sampleVolumes = {
  child: [],
  teacher: []
}
const rollingVolumeAverages = {
  child: [],
  teacher: []
}
const childSpeakingTime = ref(null)
const childSpeakingTimeOptions = ref({
        plugins: {
          title: {
            display: true,
            text: "學生積極參與比率",
            font: {
              size: 24,
              family: 'Helvetica Neue'
            }
          },
        },
        responsive: true
})

// const studentTeacherAverage = ref(null)

// const studentAveragePieOptions = ref({
//         plugins: {
//           title: {
//             display: true,
//             text: "學生積極參與比率",
//             font: {
//               size: 24,
//               family: 'Helvetica Neue'
//             }
//           },
//         },
//         responsive: true
// })

function delay(time: number) {
  return new Promise(resolve => setTimeout(resolve, time));
}

function setSessionLength(seconds: number) {
  sessionLength.value = seconds;
}

// Collections
const classes = collection(db, 'class_records');
const results = collection(db, 'results');


async function getStudentByStudentNo(studentNo: string) {
  const docRef = doc(db, "students", studentNo);
  const docSnap = await getDoc(docRef);
  return docSnap;
}

async function searchClassesByStudentNo(studentNo: string) {
  const classQuery = query(classes, orderBy("studentId"), startAt(studentNo), endAt(studentNo + '~'));
  const classSnap = await getDocs(classQuery);
  return classSnap.docs;
}

async function saveAnalysisResult(text: string, result, studentParticipationRate, student) {
  result.studentParticipationRate = studentParticipationRate;
  const docRef = await addDoc(results, {
    text,
    result,
  });
  const studentDocRef = doc(db, "students", student.studentNo);
  return await updateDoc(studentDocRef, { analyses: arrayUnion(docRef.id) })
}

async function saveStudentData(studentData) {
  await setDoc(doc(db, "students", studentData.studentNo), studentData);
  studentDataSaved.value = true;
}

function logout() {
  signOut(auth).then(
    ()=>{
      router.push('/signin');
    }
  )
}

function stopRecording () {
  audioContext.destination.disconnect();
  recordingSource.getTracks().forEach((track) => track.stop());
  audioContext.close();
  audioTranscriber.stop();
  // Analyze text
  analyzeText(transcript.value.join('.'));
}

function updateActiveSpeaker(currentIndex) {
  if (!rollingVolumeAverages['child'][currentIndex]) console.log('child averages not ready')
  if (!rollingVolumeAverages['teacher'][currentIndex]) console.log('teacher averages not ready')
  if (rollingVolumeAverages['child'][currentIndex] > rollingVolumeAverages['teacher'][currentIndex]) {
    activeSpeaker.value = 'Child';
  }
  else activeSpeaker.value = 'Teacher';
}

function updateStats() {
  childSpeakingTime.value = {
        labels: ['學生參與', '學生不參與'],
        datasets: [{
          data: [timers['child'].value / timeElapsed.value, 1-(timers['child'].value / timeElapsed.value)],
          backgroundColor: ['#41B883', '#E46651']
        }]
  }
  // studentTeacherAverage.value = {
  //       labels: ['學生', '導師'],
  //       datasets: [{
  //         data: [timers['child'].value / timeElapsed.value, timers['teacher'].value / timeElapsed.value],
  //         backgroundColor: ['#41B883', '#E46651']
  //       }]
  //     }
  
}
// This will send text to the Vertex AI Firebase Function (the ispeech-vertexai-fn must be running locally on port 5001) 
function analyzeText(text: string) {
  const request = {
    method: "POST",
    mode: "cors",
    cache: "default",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ inputText: text, inputTopic: topicInput.value })
  };
  return fetch('http://localhost:5001/predictions-ui/us-central1/prompt',request)
      .then(async data => {
          const json = await data.json();
          const analysis = json.candidates[0].content.parts[0];
          //analysisText.value = analysis.text;
          //analysisJson.value = JSON.parse(analysis.text)
          await saveAnalysisResult(text, JSON.parse(analysis.text), timers['child'].value / timeElapsed.value,  studentData.value);
          analysisFinished.value = true;
          //overallScore.value = Math.round((analysisJson.value.主題相關性評級 + analysisJson.value.內容組織評級 + analysisJson.value.情感表達評級 +  analysisJson.value.詞彙豐富度評級) / 4);
      })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function speakerWatcher(speakerLabel: string) {
  return (newValue) => {
    recordingSource = newValue;
    audioContext = new AudioContext();
    const mediaStreamSource = audioContext.createMediaStreamSource(newValue);
  
    const bufferSize = 2048;
    const processor = audioContext.createScriptProcessor(bufferSize, 2, 2);

    const timePerSample = (bufferSize / 44100) / 2;

    //mediaStreamSource.connect(audioContext.destination);
    mediaStreamSource.connect(processor);
    processor.connect(audioContext.destination);

    // Start transcription if not already started
    audioTranscriber = new AudioTrackSpeechRecognition(newValue.getAudioTracks()[0],
        (text: string) => {
            // Overwrite interim result with final result
            transcript.value[transcript.value.length - 1] = text;
            // Add a new item to transcript
            transcript.value.push('');
        }, (text: string) => {
          // Display interrim result
          transcript.value[transcript.value.length - 1] = text;
        }, 'zh-yue');
    audioTranscriber.start();

    processor.onaudioprocess = function (e) {
      // Use Left channel only
      const leftInputData = e.inputBuffer.getChannelData(0);
      const leftInputDataLength = leftInputData.length;
      let leftTotal = 0;
      for (let i = 0; i < leftInputDataLength; i++) {
          leftTotal += Math.abs(leftInputData[i++]);
      }
      const leftRms = Math.sqrt(leftTotal / leftInputDataLength);
      volumes[speakerLabel] = leftRms;
      
      sampleCounts[speakerLabel] = sampleCounts[speakerLabel] + 1
      sampleVolumes[speakerLabel][sampleCounts[speakerLabel]] = leftRms * 100
      if (!(sampleCounts[speakerLabel] % 50)) { // Every 50 samples do a rolling average of the last 50 samples
        const rollingVolumeAveragesIndex = Math.floor(sampleVolumes[speakerLabel].length/50)
        rollingVolumeAverages[speakerLabel][rollingVolumeAveragesIndex] = sampleVolumes[speakerLabel].slice(-50).reduce((p,c,i,a)=>{return p + (c/a.length)},0)
        // Queue up a call to update the active speaker being displayed
        delay(500).then(() => updateActiveSpeaker(rollingVolumeAveragesIndex)); 
      }

      if ((leftRms * 100) > 4) {
        timers[speakerLabel].value += timePerSample;
      }

      // Update Total Time Elapsed
      timeElapsed.value += timePerSample
      timers['percentElapsed'].value = timeElapsed.value / sessionLength.value

      updateStats();
  }
}
}

// const startTranscribing(track) => {{
//   if (recognition) {
//     console.log('System has speech recognition capabilities')
//     recognition = new recognition();
//     recognition.trackId = track.id;
//     recognition.continuous = true;
//     recognition.interimResults = true;
//     recognition.lang = 'zh-yue';

//     recognition.onstart = () => {
//       console.log('Recognition started');
//     };

//     recognition.onresult = function (event) {
//       let result = '';

//       for (let i = event.resultIndex; i < event.results.length; i++) {
//         if (event.results[i].isFinal) {
//           result += event.results[i][0].transcript + ' ';
//         } else {
//           result += event.results[i][0].transcript;
//         }
//       }

//       childTranscription.value = result;

//       if (result.toLowerCase().includes('stop recording')) {
//         //resultElement.innerText = result.replace(/stop recording/gi, '');
//         stopRecording();
//       }
//     };

//     recognition.onerror = function (event) {
//       console.error('Speech recognition error:', event.error);
//     };

//     recognition.onend = function () {
//       console.log('Speech recognition ended');
//     };
//   } else {
//     console.error('Speech recognition not supported');
//   }
// }}

const onStart = ()=>{
  sessionStarted.value = true;
  const { stream: stream, start: streamStart} = useUserMedia({
    constraints: {
      audio: { deviceId: selectedMic.value.deviceId }
    },
  })

  watchOnce(stream, speakerWatcher('child'))
  childStream.value = stream;
  streamStart();
}

const writeStory = ()=>{
  showStoryInputBox.value = true;
}




onMounted(async ()=>{
  auth = getAuth();
  const route = useRoute()

  if (route.query.studentcode) {
    const studentMatch = await getStudentByStudentNo(route.query.studentcode);
    if (!studentMatch.exists()) {
      console.log('could not find student:' + route.query.studentcode)
    }
    else {
      studentData.value = studentMatch.data();
      const classMatches = await searchClassesByStudentNo(route.query.studentcode);
      for (const i in classMatches) {
        const classData = classMatches[i].data();
        if (studentData.value.grade) {
          studentDataSaved.value = true;
        }
        if (classData.studentName) {
          studentData.value.studentName = classData.studentName
          break;
        }
      }
    }
  }
})

watchOnce(microphones, (newMicrophones)=>{
  selectedMic.value = newMicrophones.filter((microphone)=>microphone.label.indexOf('Built-in') > -1)[0]  
} )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          onClick: logout,
          class: "btn"
        }, "Logout")
      ]),
      (!studentDataSaved.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", null, [
              _createTextVNode("Name: "),
              _withDirectives(_createElementVNode("input", {
                class: "input-lg",
                placeholder: "Name",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((studentData.value.studentName) = $event))
              }, null, 512), [
                [_vModelText, studentData.value.studentName]
              ])
            ]),
            _createElementVNode("p", null, [
              _createTextVNode("Grade: "),
              _withDirectives(_createElementVNode("input", {
                class: "input-lg",
                placeholder: "Grade",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((studentData.value.grade) = $event))
              }, null, 512), [
                [_vModelText, studentData.value.grade]
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (saveStudentData(studentData.value))),
              type: "button",
              class: "btn btn-primary"
            }, "Next")
          ]))
        : _createCommentVNode("", true),
      (studentDataSaved.value && sessionLength.value <= 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createTextVNode(" Session Length "),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (setSessionLength(60))),
                class: "btn btn-primary"
              }, "1 minute"),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (setSessionLength(120))),
                class: "btn btn-primary"
              }, "2 minutes"),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (setSessionLength(180))),
                class: "btn btn-primary"
              }, "3 minutes"),
              _hoisted_5
            ])
          ]))
        : _createCommentVNode("", true),
      (sessionLength.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("form", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createTextVNode(" Topic: "),
                  _withDirectives(_createElementVNode("input", {
                    class: "input-lg",
                    placeholder: "Enter a Topic",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((topicInput).value = $event))
                  }, null, 512), [
                    [_vModelText, topicInput.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    class: "btn btn-primary m-1",
                    disabled: !(selectedMic.value),
                    onClick: onStart
                  }, "Start Session", 8, _hoisted_11),
                  _createElementVNode("button", {
                    class: "btn btn-primary m-1",
                    onClick: stopRecording
                  }, "Stop Recording"),
                  _createElementVNode("button", {
                    class: "btn btn-primary m-1",
                    onClick: writeStory
                  }, "Write Story")
                ])
              ])
            ]),
            (showStoryInputBox.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((storyInputBox).value = $event))
                  }, null, 512), [
                    [_vModelText, storyInputBox.value]
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (analyzeText(storyInputBox.value))),
                    class: "btn btn-primary"
                  }, "Analyze")
                ]))
              : _createCommentVNode("", true),
            (sessionStarted.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(CustomRangeSlider, {
                    id: "two",
                    "always-show-thumb": "",
                    "thumb-height": "500%",
                    modelValue: timers.percentElapsed,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((timers.percentElapsed) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (sessionStarted.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(formatTime)(timeElapsed.value)) + " / " + _toDisplayString(_unref(formatTime)(sessionLength.value)), 1))
              : _createCommentVNode("", true),
            (childStream.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_unref(AVMedia), {
                      media: childStream.value,
                      type: "frequ",
                      class: "float-right"
                    }, null, 8, ["media"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transcript.value, (item, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "card",
                        key: i
                      }, _toDisplayString(item), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              (childSpeakingTime.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_unref(Pie), {
                      id: "child-speaking-time-pie",
                      options: childSpeakingTimeOptions.value,
                      data: childSpeakingTime.value
                    }, null, 8, ["options", "data"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, [
                (analysisFinished.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                  : _createCommentVNode("", true),
                (analysisJson.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      (analysisJson.value.整體說話評分)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _hoisted_26,
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("p", _hoisted_28, [
                                _createTextVNode("主題相關性評級: "),
                                _createElementVNode("span", _hoisted_29, _toDisplayString(analysisJson.value.主題相關性評級) + " / 10", 1)
                              ]),
                              _createElementVNode("p", _hoisted_30, [
                                _createTextVNode("內容組織評級: "),
                                _createElementVNode("span", _hoisted_31, _toDisplayString(analysisJson.value.內容組織評級) + " / 10", 1)
                              ]),
                              _createElementVNode("p", _hoisted_32, [
                                _createTextVNode("情感表達評級: "),
                                _createElementVNode("span", _hoisted_33, _toDisplayString(analysisJson.value.情感表達評級) + " / 10", 1)
                              ]),
                              _createElementVNode("p", _hoisted_34, [
                                _createTextVNode("詞彙豐富度評級: "),
                                _createElementVNode("span", _hoisted_35, _toDisplayString(analysisJson.value.詞彙豐富度評級) + " / 10", 1)
                              ]),
                              _createElementVNode("p", _hoisted_36, [
                                _createTextVNode("整體評級: "),
                                _createElementVNode("b", _hoisted_37, _toDisplayString(overallScore.value) + " / 10", 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_38, _toDisplayString(analysisJson.value.整體說話評分解釋), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (analysisJson.value.改善建議和示範)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _hoisted_40,
                            _createElementVNode("div", {
                              style: {"white-space":"pre-wrap"},
                              class: "col-sm-8 text-left",
                              innerHTML: analysisJson.value.改善建議和示範
                            }, null, 8, _hoisted_41)
                          ]))
                        : _createCommentVNode("", true),
                      (analysisJson.value.unique_vocabulary_items)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _hoisted_43,
                            _createElementVNode("div", _hoisted_44, _toDisplayString(analysisJson.value.unique_vocabulary_items.length), 1),
                            _createElementVNode("div", _hoisted_45, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysisJson.value.unique_vocabulary_items, (item, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  class: "badge rounded-pill bg-light text-dark",
                                  key: index
                                }, _toDisplayString(item), 1))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (analysisJson.value.vocabulary_items_related_to_topic)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _hoisted_47,
                            _createElementVNode("div", _hoisted_48, _toDisplayString(analysisJson.value.vocabulary_items_related_to_topic.length), 1),
                            _createElementVNode("div", _hoisted_49, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysisJson.value.vocabulary_items_related_to_topic, (item, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  class: "badge rounded-pill bg-light text-dark",
                                  key: index
                                }, _toDisplayString(item), 1))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (analysisJson.value.filler_words)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            _hoisted_51,
                            _createElementVNode("div", _hoisted_52, _toDisplayString(analysisJson.value.filler_words.length), 1),
                            _createElementVNode("div", _hoisted_53, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysisJson.value.filler_words, (item, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  class: "badge rounded-pill bg-light text-dark",
                                  key: index
                                }, _toDisplayString(item), 1))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (analysisJson.value.整體情緒評級)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _hoisted_55,
                            _createElementVNode("div", _hoisted_56, [
                              (analysisJson.value.整體情緒評級 > 4)
                                ? (_openBlock(), _createBlock(EmoticonOutlineIcon, {
                                    key: 0,
                                    size: "3em"
                                  }))
                                : _createCommentVNode("", true),
                              (analysisJson.value.整體情緒評級 == 4)
                                ? (_openBlock(), _createBlock(EmoticonHappyOutlineIcon, {
                                    key: 1,
                                    size: "3em"
                                  }))
                                : _createCommentVNode("", true),
                              (analysisJson.value.整體情緒評級 == 3)
                                ? (_openBlock(), _createBlock(EmoticonNeutralOutlineIcon, {
                                    key: 2,
                                    size: "3em"
                                  }))
                                : _createCommentVNode("", true),
                              (analysisJson.value.整體情緒評級 == 2)
                                ? (_openBlock(), _createBlock(EmoticonSadOutlineIcon, {
                                    key: 3,
                                    size: "3em"
                                  }))
                                : _createCommentVNode("", true),
                              (analysisJson.value.整體情緒評級 < 2)
                                ? (_openBlock(), _createBlock(EmoticonFrownOutlineIcon, {
                                    key: 4,
                                    size: "3em"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_57, _toDisplayString(analysisJson.value.整體情緒評級解釋), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (analysisJson.value.家長的小提示)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            _hoisted_59,
                            _createElementVNode("div", {
                              style: {"white-space":"pre-wrap"},
                              class: "col-sm-6 text-left",
                              innerHTML: analysisJson.value.家長的小提示
                            }, null, 8, _hoisted_60)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_61, [
      _createElementVNode("div", _hoisted_62, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedMic).value = $event)),
          class: "form-control"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(microphones), (microphone) => {
            return (_openBlock(), _createElementBlock("option", {
              key: microphone.deviceId,
              value: microphone
            }, _toDisplayString(microphone.label), 9, _hoisted_63))
          }), 128))
        ], 512), [
          [_vModelSelect, selectedMic.value]
        ])
      ])
    ])
  ], 64))
}
}

})